function toLocaleStringSupportsOptions () {
  return !!(typeof Intl === 'object' && Intl &&
    typeof Intl.NumberFormat === 'function')
}

export default function formatNumber (number) {
  // NOTE: This native method is not supported in < Safari 10. When we drop
  // support for < Safari 10, we can remove the conditional and the fallback
  // path.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
  if (toLocaleStringSupportsOptions()) {
    if (typeof number !== 'number') { return number || '0' }
    return number.toLocaleString()
  }

  // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript/2901298#2901298
  const parts = (number || '').toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.') || '0'
}
